/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
// import { timeFormat } from "d3-time-format";
import Gettext from "../common/Gettext";

import * as Types from "./NextGenChartTypes";
import { rgba } from "polished";
import { fontSize } from "../common/styled-mixins";

const VerticalBarView = styled.div`
  position: absolute;
  height: 100%;
  top: 0px;
  left: 0px;
`;

const VerticalBarLine = styled.div`
  position: absolute;
  top: 29px;
  bottom: 48px;
  left: 0px;
  border-left: 1px solid ${props => props.theme.ticksBorderColor};

  ${props =>
    props.mobile &&
    css`
      top: 24px;
      bottom: 0px;

      ${props =>
        !props.opening &&
        css`
          top: 29px;
          bottom: 3px;
          width: 1px;
          background-image: linear-gradient(
            to top,
            ${props => props.theme.ticksBorderColor} 60%,
            rgba(255, 255, 255, 0) 0%
          );
          background-position: right;
          background-size: 1px 10px;
          background-repeat: repeat-y;
          border-left: none;
        `};
    `};
`;

const VerticalBarCaption = styled.div`
  position: absolute;
  right: ${props => (props.switchSide ? -15 : 15)}px;
  top: 31px;
  font-size: ${fontSize(9, 16)};
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
  transform: rotate(-90deg);
  transform-origin: right;
  color: ${props => props.theme.ticksFontColor};
  user-select: none;

  ${props =>
    props.mobile &&
    css`
      top: 26px;
      right: ${props => (props.switchSide ? -7 : 7)}px;
      font-size: ${fontSize(8, 11)};
      letter-spacing: 0.5px;
    `};
`;

const HorizontalBarView = styled.div`
  position: absolute;
  width: 100%;
  top: 0px;
  opacity: 0.9;
`;

const HorizontalBarLine = styled.div`
  position: absolute;
  left: 0;
  right: ${props => (props.noFit ? "88px" : "171px")};
  height: 0;
  border-top: ${({ theme }) => `1px dashed ${rgba(theme.accent, 0.7)}`};

  ${props =>
    props.mobile &&
    css`
      right: 60px;
    `};
`;

const HorizontalBarCaption = styled.div`
  position: absolute;
  left: 100%;
  top: -10px;
  margin-left: ${props =>
    props.fits ? (props.noFit ? "-82px" : "-166px") : "-112px"};
  transition: margin-left 0.3s ease;
  min-width: 79px;
  height: 21px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding-right: 10px;
  padding-left: 3px;
  text-align: right;
  font-weight: 300;
  font-size: ${fontSize(14, 14)};
  background-color: ${({ theme }) => theme.barCaption};
  color: ${({ theme }) => theme.foreground};
  white-space: nowrap;

  :after {
    position: absolute;
    right: 100%;
    top: 50%;
    width: 0;
    height: 0;
    margin-top: -11px;
    border: solid transparent;
    border-top-width: 11px;
    border-bottom-width: 10px;
    border-right-width: 6px;
    border-right-color: ${({ theme }) => theme.barCaption};
    pointer-events: none;
    content: "";
  }

  ${props =>
    props.mobile &&
    css`
      top: -8px;
      min-width: 55px;
      max-width: 61px;
      margin-left: -55px;
      height: 16px;
      padding: 0 4px;
      font-size: 10px;
      line-height: 16px;
      background-color: ${({ theme }) => rgba(theme.barCaption, 0.7)};

      :after {
        margin-top: -8px;
        border-top-width: 8px;
        border-bottom-width: 8px;
        border-right-width: 5px;
        border-right-color: ${({ theme }) => rgba(theme.barCaption, 0.7)};
      }
    `};
`;

/*const CursorBar = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`;*/

/*const CursorBarHLine = styled.div`
  position: absolute;
  left: 0px;
  right: 163px;
  border-top: 1px solid ${({ theme }) => theme.foreground};
  opacity: 0.29;
  pointer-events: none;
`;*/

/*const CursorBarVLine = styled.div`
  position: absolute;
  top: 29px;
  bottom: 71px;
  border-left: 1px solid ${({ theme }) => theme.foreground};
  opacity: 0.29;
  pointer-events: none;
`;*/

/*const CursorBarCaption = styled.div`
  position: absolute;
  height: auto;
  font-weight: 300;
  font-size: ${fontSize(12, 12)};
  line-height: 20px;
  background-color: ${({ theme }) => rgba(theme.foreground, 0.8)};
  color: ${({ theme }) => theme.cursorBarCaption};
  white-space: nowrap;
  pointer-events: none;
`;*/

/*const CursorBarHCaption = styled(CursorBarCaption)`
  right: 85px;
  top: -9px;
  width: 69px;
  text-align: right;
  padding-right: 10px;

  :after {
    content: "";
    position: absolute;
    right: 100%;
    top: 50%;
    width: 0px;
    height: 0px;
    margin-top: -9px;
    border: solid transparent;
    border-top-width: 9px;
    border-bottom-width: 9px;
    border-right-width: 6px;
    border-right-color: ${({ theme }) => rgba(theme.foreground, 0.8)};
    pointer-events: none;
  }
`;*/

/*const CursorBarVCaption = styled(CursorBarCaption)`
  margin-left: -50px;
  bottom: 48px;
  width: 100px;
  padding: 0 10px;
  text-align: center;
  z-index: 1;
`;*/

const CandleCursorCaption = styled.div`
  position: absolute;
  left: 29px;
  top: 28px;
  color: ${props => props.theme.ticksFontColor};
  font-size: ${fontSize(11)};
  line-height: 15px;
  user-select: none;
`;

type VerticalBarProps = {
  x: number,
  children: React.Node,
  opening?: boolean,
  mobile?: boolean,
  switchSide?: boolean
};

export function VerticalBar(props: VerticalBarProps) {
  const positionX = Math.floor(props.x);

  return (
    <VerticalBarView
      style={{
        WebkitTransform: `translateX(${positionX}px)`,
        transform: `translateX(${positionX}px)`
      }}
    >
      <VerticalBarLine mobile={props.mobile} opening={props.opening} />
      <VerticalBarCaption mobile={props.mobile} switchSide={props.switchSide}>
        {props.children}
      </VerticalBarCaption>
    </VerticalBarView>
  );
}

type HorizontalBarProps = {
  value: number,
  y: number,
  toFixed: number,
  viewportHeight: number,
  mobile?: boolean
};

export function HorizontalBar({
  value,
  y,
  noFit = false,
  toFixed = 6,
  viewportHeight,
  mobile
}: HorizontalBarProps) {
  const positionY = noFit ? y : Math.max(10, Math.min(viewportHeight - 30, y));

  const fits = noFit || positionY === y;

  const caption = value.toFixed(toFixed);

  return (
    <HorizontalBarView
      style={{
        WebkitTransform: `translateY(${positionY}px)`,
        transform: `translateY(${positionY}px)`
      }}
    >
      {fits && <HorizontalBarLine mobile={mobile} noFit={noFit} />}
      <HorizontalBarCaption mobile={mobile} fits={fits} noFit={noFit}>
        {caption}
      </HorizontalBarCaption>
    </HorizontalBarView>
  );
}

type Scale = ((input: number) => number) & {
  invert?: (input: number) => number
};

type ScopeProps =
  | {
      type: "line",
      scaleX: Scale,
      scaleY: Scale,
      x: number,
      value: Types.RenderablePoint
    }
  | {
      type: "bar" | "candlestick",
      scaleX: Scale,
      scaleY: Scale,
      x: number,
      value: Types.RenderableCandle
    };

export function Scope(props: ScopeProps) {
  /*const captionX = props.scaleX.invert(props.x);
  const captionY =
    props.type === "line" ? props.value[2].value : props.value.close[2].value;

  const y = props.type === "line" ? props.value[1] : props.value.close[1];*/

  return (
    <React.Fragment>
      {/*<CursorBar>
        {!props.secondary && (
          <CursorBarVLine
            style={{
              WebkitTransform: `translateX(${props.x}px)`,
              transform: `translateX(${props.x}px)`
            }}
          />
        )}
        <CursorBarHLine
          style={{
            WebkitTransform: `translateY(${y}px)`,
            transform: `translateY(${y}px)`
          }}
        />
        <CursorBarHCaption
          style={{
            WebkitTransform: `translateY(${y}px)`,
            transform: `translateY(${y}px)`
          }}
        >
          {`${captionY.toFixed(6)}`}
        </CursorBarHCaption>
        {!props.secondary && (
          <CursorBarVCaption
            style={{
              WebkitTransform: `translateX(${props.x}px)`,
              transform: `translateX(${props.x}px)`
            }}
          >
            {timeFormat("%d/%m %H:%M:%S")(captionX)}
          </CursorBarVCaption>
        )}
      </CursorBar>*/}

      {props.type !== "line" && (
        <CandleCursorCaption>
          <table border="none">
            <tbody>
              <tr>
                <td style={{ paddingRight: 5 }}>
                  <Gettext>Open</Gettext>
                </td>
                <td>{props.value.open[2].value}</td>
              </tr>
              <tr>
                <td style={{ paddingRight: 5 }}>
                  <Gettext>High</Gettext>
                </td>
                <td>{props.value.maximum[2].value}</td>
              </tr>
              <tr>
                <td style={{ paddingRight: 5 }}>
                  <Gettext>Low</Gettext>
                </td>
                <td>{props.value.minimum[2].value}</td>
              </tr>
              <tr>
                <td style={{ paddingRight: 5 }}>
                  <Gettext>Close</Gettext>
                </td>
                <td>{props.value.close[2].value}</td>
              </tr>
            </tbody>
          </table>
        </CandleCursorCaption>
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Chart/Bars.js